import { Api } from '@/services/Api';

export default {
    /*  1. Get all data */
    getID_POST_ISSUE_LOGs(body = { keyword: '' }) {
        return Api().post('/ID_POST_ISSUE_LOG/GetID_POST_ISSUE_LOGByCriteria', body);
    },
    /*  2. Get one column */

    getID_POST_ISSUE_LOG(id) {
        return Api().get(`/ID_POST_ISSUE_LOG/${id}`);
    },
    /*  3. Create one column */

    saveID_POST_ISSUE_LOG(body) {
        return Api().post(`/ID_POST_ISSUE_LOG`, body);
    },
    /*  4. Delete one or more columns */
    deleteID_POST_ISSUE_LOG(id_POST_ISSUE_LOG) {
        return Api().post(`/ID_POST_ISSUE_LOG/DeleteID_POST_ISSUE_LOG`, id_POST_ISSUE_LOG);
    },
    /*  5. post one or more columns */
    postID_POST_ISSUE_LOG(id_POST_ISSUE_LOG) {
        return Api().post(`/ID_POST_ISSUE_LOG/PostID_POST_ISSUE_LOG`, id_POST_ISSUE_LOG);
    }
};
